import { getData, postData } from './index';
import { ERROR_COMPANY } from './types';
import axios from 'axios';

export const API_URL = process.env.REACT_APP_API_URL;

export async function createLunchCheckout(dispatch, data) {
  const url = '/payment/lunch/checkout';
  let response;

  await postData(ERROR_COMPANY, true, url, dispatch, data).then((res) => {
    response = res;
  });

  return response;
}

export async function getLunchPaymentStatus(dispatch, sessionId) {
  const url = `/payment/lunch/status?session_id=${encodeURIComponent(sessionId)}`;
  let response;

  await getData(ERROR_COMPANY, url, dispatch, true).then((res) => {
    response = res.data;
  });

  return response;
}

export async function getLunchReceipt(dispatch, userId) {
  const url = `/payment/lunch/receipt?userId=${encodeURIComponent(userId)}`;
  let response;

  await getData(ERROR_COMPANY, url, dispatch, true).then((res) => {
    response = res.data;
  });

  return response;
}

export async function createLunchCheckoutPublic(exhibitionId, data) {
  const response = await axios.post(
    `${API_URL}/payment/lunch/checkout/public`,
    data,
    {
      headers: {
        exhibition: exhibitionId,
        'Content-Type': 'application/json',
      },
    }
  );
  return response.data;
}

export async function getLunchPaymentStatusPublic(sessionId) {
  const response = await axios.get(
    `${API_URL}/payment/lunch/status/public?session_id=${encodeURIComponent(sessionId)}`
  );
  return response.data;
}

export async function checkLunchPaymentByEmail(dispatch, email, userId, dates) {
  const params = new URLSearchParams({ email });
  if (userId) params.set('userId', userId);
  if (dates && dates.length) params.set('dates', JSON.stringify(dates));
  const url = `/payment/lunch/check?${params.toString()}`;
  let response;

  await getData(ERROR_COMPANY, url, dispatch, true).then((res) => {
    response = res.data;
  });

  return response;
}

export async function checkLunchPaymentByEmailPublic(exhibitionId, email, userId, dates) {
  const params = new URLSearchParams({ email });
  if (userId) params.set('userId', userId);
  if (dates && dates.length) params.set('dates', JSON.stringify(dates));
  const response = await axios.get(
    `${API_URL}/payment/lunch/check/public?${params.toString()}`,
    {
      headers: {
        exhibition: exhibitionId,
      },
    }
  );
  return response.data;
}
